import { render, staticRenderFns } from "./PtAbout.vue?vue&type=template&id=ccad5792&scoped=true"
import script from "./PtAbout.vue?vue&type=script&lang=js"
export * from "./PtAbout.vue?vue&type=script&lang=js"
import style0 from "./PtAbout.vue?vue&type=style&index=0&id=ccad5792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccad5792",
  null
  
)

export default component.exports